import AuthTopBar from "../component/AuthTopBar";
import { useNavigate } from "react-router-dom";
import GoogleSignIn from "../component/GoogleSignIn";
import AuthForm from "../component/AuthForm";
import { useEffect, useState } from "react";
import { useAppServices } from "../../../hook/services";
import { Toast } from "../../../components/Toast/Toast";
import { useUserInfo } from "../../../context/user";
import localforage from "localforage";

const Signup = () => {
  const params = "";
  const queryString = window.location.search;
  const planId = new URLSearchParams(queryString).get("plan");
  const type = new URLSearchParams(queryString).get("type");
  const Service = useAppServices();
  const updateUser = useUserInfo()[1];
  const logout = useUserInfo()[2];
  const [loader, setLoader] = useState(false);
  const [whitelabel, setwhitelabel] = useState("");
  const [plan, setPlan] = useState(null);
  const navigate = useNavigate();
  const [toast, setToast] = useState({
    message: "",
    type: "error",
    isVisible: false,
    subMessage: "",
  });
  const [formInputs, setFormInputs] = useState({
    email: "",
    password: "",
    type: "email",
    userName: "",
  });

  const fetchPlanById = async () => {
    if (planId || whitelabel?._id) {
      const { response } = await Service.saas.fetchPlanById({
        query: `id=${planId}&agency_id=${whitelabel?._id
          }`,
      });
      if (response?.data) {
        setPlan(response?.data);
      }
    }
  };

  useEffect(() => {
    fetchPlanById();
  }, [planId, whitelabel]);

  const getting_whitelable_domain = async () => {
    const currentURL = window.location.href;
    const urlObject = new URL(currentURL);
    const domain = urlObject.hostname;
    const payload = {
      domain: domain,
    };
    const { response, error } = await Service.agency.getwhitelabel({
      payload: payload,
    });
    if (response) {
      setwhitelabel(response.data);
    }
  };
  useEffect(() => {
    getting_whitelable_domain();
  }, []);

  const handleFormChange = (e) => {
    setFormInputs({ ...formInputs, [e.target.name]: e.target.value });
  };

  const handleFormSubmit = async (user) => {
    setLoader(true);
    const { response, error } = await Service.auth.signup({
      payload: user?.email
        ? {
          ...user,
          agency_id: whitelabel?._id,
          ...(plan && { plan_id: plan?._id }),
          ...(type ? { planType: type } : { planType: "monthly" }),
        }
        : {
          ...formInputs,
          agency_id:
            whitelabel?._id,
          ...(plan && { plan_id: plan?._id }),
          ...(type ? { planType: type } : { planType: "monthly" }),
        },
    });
    if (response?.success) {
      setTimeout(async () => {
        if (user?.type === "google") {
          updateUser(response?.data);
          navigate("/auth/account-setup");
        } else {
          navigate("/auth/verify-email");
        }
      }, 1000)
    } else {
      setToast({
        message: error.message,
        type: "error",
        subMessage: "Please try again",
        isVisible: true,
      });
    }
    setLoader(false);
    setTimeout(
      () =>
        setToast({
          message: "",
          type: "error",
          subMessage: "",
          isVisible: false,
        }),
      3000
    );
  };

  return (
    <div className="h-screen bg-white">
      <AuthTopBar />
      <div className="relative flex justify-center">
        <p className="text-[#757575] absolute top-7 right-12">
          Already have an account?{" "}
          <button
            onClick={() => {
              logout();
              navigate("/auth/sign-in");
            }}
            className="text-[#1E1E1E]"
          >
            Sign in
          </button>
        </p>
        <div className="text-center">
          <h1 className="font-semibold text-3xl mt-[58px]">{`Create ${plan?.product_name ?? "Starter AI"
            } Account`}</h1>
          <p className="mt-3 text-center">
            Join thousands of businesses transforming with AI in minutes
          </p>
          <GoogleSignIn
            buttonText={"Sign up with Google"}
            enabled
            onSuccess={handleFormSubmit}
            onUnavailable={(message) =>
              setToast({
                message,
                type: "error",
                subMessage: "Please try again",
                isVisible: true,
              })
            }
          />
          <p className="relative border-b !border-[#D9D9D9] my-6">
            <span className="absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 px-4 text-[#B3B3B3] py-2 bg-white">
              OR
            </span>
          </p>
          <p className="mb-8">Enter your email and password below to create your account</p>
          <AuthForm
            formInputs={formInputs}
            onChange={handleFormChange}
            formType="signup"
            showPasswordRequirements
            handleSubmit={handleFormSubmit}
            loader={loader}
          />
        </div>
      </div>
      <Toast
        duration={300}
        message={toast.message}
        subMessage={toast.subMessage ?? ""}
        type={toast.type}
        visible={toast.isVisible}
      />
    </div>
  );
};

export default Signup;
